
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

define('component!Pricing/PricingOrganizationPickerComponent',['require','translate','react','create-react-class','bluebird','classnames','component!ModalComponent','component!Spinner','lib/backbone/Backbone.Mixins.Transport.API','lib/view_helpers/base','lib/Podio.Routes','models/Podio.Models.User'],function (require) {
  'use strict';

  var t = require('translate');
  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var Promise = require('bluebird');
  var cx = require('classnames');

  var ModalComponent = require('component!ModalComponent');
  var Spinner = require('component!Spinner');
  var API = require('lib/backbone/Backbone.Mixins.Transport.API');
  var viewHelpers = require('lib/view_helpers/base');
  var routes = require('lib/Podio.Routes');
  var User = require('models/Podio.Models.User');

  var user = new User();

  var PricingOrganizationPickerComponent = ReactCreateClass({
    displayName: 'PricingOrganizationPickerComponent',

    getDefaultProps: function getDefaultProps() {
      return {
        isOpen: false
      };
    },

    getInitialState: function getInitialState() {
      this.select = React.createRef();
      this.modal = React.createRef();
      return {
        organizations: [],
        currentOrganization: null,
        isLoading: false,
        isInitialLoading: true
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this = this;

      // Orgs provisioned from external channels should not see the pricing page
      var provisionedChannels = ['apple', 'auto', 'sfplatinum', 'coffee', 'workflow_bundle', 'enterprise'];

      Promise.all([API.request('GET', '/contract/org'), API.request('GET', '/contract')]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var userOrgs = _ref2[0];
        var userContracts = _ref2[1];

        var notAllowedOrgs = userContracts.filter(function (contract) {
          return provisionedChannels.find(function (channel) {
            return contract.accounting_provider === channel;
          });
        }).map(function (contract) {
          return contract.org.org_id;
        });

        return userOrgs.filter(function (org) {
          return !notAllowedOrgs.find(function (excludedOrgId) {
            return org.org_id === excludedOrgId;
          });
        });
      }).then(function (orgs) {
        if (orgs.length === 1) {
          _this.setState({ currentOrganization: orgs[0] }, _this.goToPricing);
        } else {
          _this.setState({
            organizations: orgs,
            currentOrganization: orgs[0],
            isInitialLoading: false
          });
        }
      });

      user.setProperty('tier_upgrade_return_url', { url: window.location.href });
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'pricing-organization-picker-component' },
        React.createElement(
          ModalComponent,
          _extends({ ref: this.modal }, this.props),
          this.state.isInitialLoading ? this.renderLoading() : this.renderContent()
        )
      );
    },

    renderLoading: function renderLoading() {
      return React.createElement(
        'div',
        { className: 'modal-content loader' },
        React.createElement(Spinner, null)
      );
    },

    renderContent: function renderContent() {
      return React.createElement(
        'div',
        { className: 'modal-content' },
        React.createElement('img', { className: 'org-icon', src: viewHelpers.image_url('components/PricingOrganizationPickerComponent/org_icon.png') }),
        this.state.organizations.length === 0 ? this.renderEmpty() : this.renderList()
      );
    },

    renderEmpty: function renderEmpty() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'p',
          null,
          t("You don't have any organizations you can upgrade.#tier.picker")
        ),
        React.createElement(
          'span',
          null,
          t('If you would like to create an organization, head #tier.picker'),
          React.createElement(
            'a',
            { href: '#organization/setup', onClick: this.close },
            ' ',
            t('here #tier.picker')
          )
        ),
        React.createElement('p', null)
      );
    },

    renderList: function renderList() {
      var classSet = cx({
        'button-new': true,
        'primary': true,
        'loader': this.state.isLoading
      });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'p',
          null,
          t('You have more than one organization in your account #tier.picker')
        ),
        React.createElement(
          'span',
          null,
          t('Is this the organization you would like to upgrade? #tier.picker')
        ),
        React.createElement(
          'p',
          { className: 'select-container' },
          React.createElement(
            'select',
            { className: 'styled', onChange: this.handleSelectChange, ref: this.select },
            this.state.organizations.map(function (org, index) {
              return React.createElement(
                'option',
                { key: index, value: org.id },
                org.name
              );
            })
          )
        ),
        React.createElement(
          'span',
          { className: 'modal-org-note' },
          React.createElement(
            'b',
            null,
            'Note: '
          ),
          t('To upgrade, ensure the organization contains at least one workspace #tier.picker')
        ),
        React.createElement(
          'p',
          null,
          React.createElement(
            'a',
            { onClick: this.handleContinueClick, href: '#', className: classSet },
            t('CONTINUE TO PRICING #tier.picker')
          )
        )
      );
    },

    handleSelectChange: function handleSelectChange() {
      var selectedIndex = this.select.current.selectedIndex;

      this.setState({
        currentOrganization: this.state.organizations[selectedIndex]
      });
    },

    handleContinueClick: function handleContinueClick() {
      if (this.state.isLoading) {
        return false;
      }

      this.setState({
        isLoading: true
      });

      this.goToPricing();

      return false;
    },

    goToPricing: function goToPricing() {
      window.location.href = routes.organization_upgrade_router_path(this.state.currentOrganization.url_label, { format: 'html' });
    },

    open: function open() {
      var _this2 = this;

      this.modal.current.open();

      if (this.state.organizations.length > 0) {
        setTimeout(function () {
          var node = _this2.select.current;

          node.focus();
        }, 0);
      }
    },

    close: function close() {
      this.modal.current.close();
    }
  });

  return PricingOrganizationPickerComponent;
});
